import React from "react";
import { SxStyleProp } from "theme-ui";
import { Box as BoxBase, BoxProps } from "rebass";
import { SVGProps } from "../icons/SVG";

export interface Props extends Omit<BoxProps, "css">, SVGProps {
  sx?: SxStyleProp;
}

const Box: React.FunctionComponent<Props> = React.forwardRef(
  ({ ...restProps }, ref) => <BoxBase ref={ref} {...restProps} />,
);

Box.displayName = "Box";

export default Box;
